<template>
  <div class="hypto-loader" v-if="isHyptoLoader">
    <div class="wrapper">
      <img src="@/assets/images/hypto-loader.svg" alt="hypto-loader"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HyptoLoader',
  computed: {
    ...mapGetters(['isHyptoLoader'])
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .hypto-loader {
    @include custom-flex();
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(1, 1, 1, 0.5);
    height: 100vh;
    width: 100vw;
    z-index: 1000;

    .wrapper {
      background: $white;
      height: 100px;
      width: 100px;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;

      img {
        height: 80px;
        animation: in-out .500s linear alternate infinite;
      }
    }
  }

  @keyframes in-out {
    0% {
      transform: scale(0.8, 0.8)
    }
    100% {
      transform: scale(1, 1)
    }
  }
</style>
